import type { AdminNotificationStackItem } from '@/lib/admin-notification-stack.types';

/** Query params appended when navigating to a critical Fix destination. */
export const SURFACE_ALERTS_PARAM = 'surfaceAlerts';
export const ALERT_KEY_PARAM = 'alertKey';

export function buildCriticalFixNavigationHref(item: AdminNotificationStackItem): string | null {
  if (item.onAction || !item.actionHref) return null;
  if (/^https?:\/\//i.test(item.actionHref)) return item.actionHref;

  try {
    const url = new URL(item.actionHref, window.location.origin);
    url.searchParams.set(SURFACE_ALERTS_PARAM, '1');
    url.searchParams.set(ALERT_KEY_PARAM, item.id);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return item.actionHref;
  }
}

export function readSurfaceAlertsFromUrl(search = window.location.search): {
  surfaceAlerts: boolean;
  alertKey: string | null;
} {
  const params = new URLSearchParams(search);
  return {
    surfaceAlerts: params.get(SURFACE_ALERTS_PARAM) === '1',
    alertKey: params.get(ALERT_KEY_PARAM)?.trim() || null,
  };
}

export function isNotificationsInboxPath(pathname = window.location.pathname): boolean {
  const normalized = pathname.replace(/^\/+/, '').replace(/\/+$/, '');
  return normalized === 'notifications.html';
}
